import { get } from 'lodash-es';

export type GenericFeatureValue = boolean | string | null;

export type GetFeatureFlag<Value = GenericFeatureValue> = (
    featureFlags?: Record<string, unknown>,
    overrides?: Record<string, unknown>,
) => (key: string, defaultValue?: Value) => Value;

export const getFeatureFlag: GetFeatureFlag = (featureFlags = {}, overrides = {}) => {
    return (key, defaultValue = false) => {
        const featureFlagsDictionary = { ...featureFlags, ...overrides };

        const value = get(featureFlagsDictionary, key, defaultValue);
        if (value === 'true' || value === 'false') {
            return JSON.parse(value);
        }

        return value;
    };
};
